import produce from 'immer';
import { NFT_GENERATE_LIST_REQUEST, NFT_GENERATE_SEAL_LIST_REQUEST } from '../../constants/app/nftConstants';

const initialState = {

};

const nftReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_GENERATE_SEAL_LIST_REQUEST:
      break;
    case NFT_GENERATE_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default nftReducer;
